import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

// GET /api/v1/pos/receipt_template -- resolved (store override or org default,
// logo falls back independently) server-side from the POS JWT, no params.
// One cache entry for the whole session (no query args); prefetched at login
// in AuthInitializer so it's already warm by the time checkout/print happens.
// See apex_v3 docs/features/pos-receipt-template/overview.md for the full contract.
export const receiptTemplateApi = createApi({
  reducerPath: 'receiptTemplateApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ReceiptTemplate'],
  endpoints: (builder) => ({
    getReceiptTemplate: builder.query({
      query: () => '/receipt_template',
      providesTags: [{ type: 'ReceiptTemplate', id: 'CURRENT' }],
      // Response: { data: { terms, footer_message, discount_display_mode,
      //   savings_message_template, show_total_paid_row, website_handle,
      //   instagram_handle, declaration_text, logo_url, ... } }
      transformResponse: (response) => response?.data || null,
    }),
  }),
});

export const { useGetReceiptTemplateQuery } = receiptTemplateApi;
